import React, { useEffect, useRef, useState } from "react";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";
import { RiGithubLine } from "react-icons/ri";
import { Link } from "react-router-dom";

const Navbar = () => {
  const navRef = useRef();
  const [nav, setNav] = useState(false);

  const showNav = () => {
    navRef.current.classList.add("show");
    setNav(true);
  };

  const hideNav = () => {
    navRef.current.style.display = "none";
    navRef.current.classList.remove("show");
    setNav(false);
  };

  useEffect(() => {
    if (nav) {
      document.body.style.height = "100vh";
      document.body.style.overflowY = "hidden";
    } else {
      document.body.style.height = "auto";
      document.body.style.overflowY = "auto";
    }
  }, [nav]);

  return (
    <nav className="d-flex Navbar">
      <div className="d-flex justify-content-between align-items-center u-width">
        <div className="logo">MH</div>
        {/* {window.matchMedia("(max-width: 550px)").matches && !nav && (
          <GiHamburgerMenu size={22} cursor="pointer" onClick={showNav} />
        )}
        {window.matchMedia("(max-width: 550px)").matches && nav && (
          <IoMdClose
            size={22}
            cursor="pointer"
            onClick={hideNav}
            color="white"
          />
        )}
        <div className="nav-list d-flex" ref={navRef}>
          <a href="#aboutSection">About</a>
          <Link to="/">Skills</Link>
          <Link to="/">Work</Link>
          <Link to="/">Contact</Link>
        </div> */}
        <div className="d-flex justify-content-center mt-2">
          <a
            href="https://wa.me/03445059989"
            target={"_blank"}
            className="icon text-white"
          >
            <AiOutlineWhatsApp size={22} />
          </a>
          <a
            target={"_blank"}
            href="https://www.linkedin.com/in/muhammad-hasnainn/"
            className="text-white icon ms-3"
          >
            <FaLinkedinIn size={22} />
          </a>
          <a
            href="https://github.com/Muhammadhasnainn"
            target={"_blank"}
            className="text-white icon ms-3"
          >
            <RiGithubLine size={22} />
          </a>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
